<template>
  <layout>
    <template v-slot:title>Finalise Document</template>
    <success v-if="finalized"
      >All content controls have been removed from this document.</success
    >
    <div v-else>
      <information
        >Finalising a document removes all dynamic controls from the document
        and cannot be reversed. It will no longer be possible to refresh the
        document contents automatically.</information
      >
      <div class="remove-button-container">
        <button type="button" class="btn btn-primary" @click="finalizeClicked">
          Remove all Content Controls
        </button>
      </div>
    </div>
  </layout>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import { Information, Success } from "@/components/common/banners";
import contentControls from "@/services/word/contentControlsService";

const finalizeClicked = async function() {
  this.logDebug("Finalizing document.");

  try {
    const model = this.documentModel;
    const allControls = model.allContentControls();

    for (let i = 0; i < allControls.length; i++) {
      const control = allControls[i];
      await contentControls.delete(control.id, true);
      this.logDebug("Deleted content control.", { id: control.id });
    }

    model.contentControls = [];
    await this.saveDocumentModel(model);
    this.logDebug("Document model saved.", model);
    this.finalized = true;
  } catch (error) {
    this.logError("Error finalizing document.", { error });
    throw error;
  }
};

export default {
  components: { Information, Success },
  mixins: [documentModelMixin],
  data: function() {
    return {
      finalized: false,
    };
  },
  methods: {
    finalizeClicked,
  },
};
</script>
<style lang="scss" scoped>
.remove-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
